import form from "./schemas/form";
import validations from "./schemas/validations";
import { useEffect, useState } from "react";
import initialValues from "./schemas/initialValues";
import axios from "axios";
import { API_URL } from "../../../config";
import { useParams } from 'react-router-dom';
import {getProductService, updateProductService} from "../../../services/productService";

const useEditProduct = () => {

    const { id } = useParams();

    const {formId, formField} = form;

    const [values, setValues] = useState(initialValues);

    const [isLoading, setIsLoading] = useState(true);

    const [snackbarConfig, setSnackbarConfig] = useState({
        color: 'success',
        title: '',
        message: '',
        icon: 'notifications'
    });
    const [show, setShow] = useState(false);
    const toggleSnackbar = () => setShow(!show);

    useEffect(() => {
        const init = async () => {
            setIsLoading(true);
            await loadRecord();
            setIsLoading(false);
        };

        init();
    }, []);

    const loadRecord = async () => {
        try {
            const response = await getProductService(id);
            setValues(response.data.data);
        } catch (error) {
            setSnackbarConfig({
                message: "Something went wrong loading the product",
                icon: 'cancel',
                title: 'Products',
                color: 'warning'
            });

            setShow(true);
        }
    };

    const handleSubmit = async (values, actions) => {
        try {
            // Send data to API
            await updateProductService(id, values)

            setSnackbarConfig({
                message: 'Producto actualizado exitosamente',
                icon: 'notifications',
                title: 'Productos',
                color: 'success'
            });

            setShow(true);

        } catch (error) {
            setSnackbarConfig({
                message: error.response.data.message,
                icon: 'cancel',
                title: 'Productos',
                color: 'warning'
            });

            setShow(true);
        }

        actions.setSubmitting(false);
    };

    return {
        formId,
        formField,
        validations,
        values,
        isLoading,
        snackbarConfig,
        show,
        toggleSnackbar,
        handleSubmit
    }
};

export default useEditProduct;
